import { PageTitle } from '@app/components/common/PageTitle/PageTitle';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useParams } from 'react-router-dom';
import { Col, Row } from 'antd';
import { BaseBreadcrumb, BaseBreadcrumbWithRender } from '@app/components/common/BaseBreadcrumb/BaseBreadcrumb';
import ImportForm from '@app/components/apps/Import/ImportForm';
import { useHeader } from '@app/components/header/layouts/HeaderContext';

const breadcrumbMap: Record<string, { path: string; name: string }> = {
  NORMAL: { name: 'Imports - Normal', path: '/import/normal' },
  NON_COMPLIANCE_1: { name: 'Imports: Non-Compliance 1', path: '/import/non-compliance-1' },
  NON_COMPLIANCE_3: { name: 'Imports: Non-Compliance 3', path: '/import/non-compliance-3' },
  NO_OBJECTION: { name: 'Imports - No Objection', path: '/import/no-objection' },
  NON_RELEVANT: { name: 'Imports: Non-Relevant', path: '/import/non-relevant' },
};

export const ViewImportPage: React.FC = () => {
  const location = useLocation();
  const { id } = location.state || {};
  const { t } = useTranslation();
  const [currentBreadcrumName, setCurrentBreadcrumName] = useState<string>('View Import');
  const { setBreadcrumb, clearHeaderButtons } = useHeader();

  const ImportType = localStorage.getItem('selected_import_type') || 'NORMAL';
  const categoryData = breadcrumbMap[ImportType] || { path: '/import/normal', name: 'Imports' };

  useEffect(() => {
    const routes = [
      { path: categoryData.path, breadcrumbName: categoryData.name },
      { path: '/view-import', breadcrumbName: currentBreadcrumName },
    ];

    setBreadcrumb(<BaseBreadcrumbWithRender routes={routes} separator=">" />);

    return () => {
      setBreadcrumb(undefined);
      clearHeaderButtons();
    };
  }, [currentBreadcrumName, ImportType, categoryData.path, categoryData.name]);

  return (
    <>
      <Row gutter={[16, 16]}>
        <Col span={24}>
          <ImportForm
            type={'view'}
            editable={false}
            id={id}
            pageTitle={`View Import`}
            setCurrentBreadcrumName={setCurrentBreadcrumName}
          />
        </Col>
      </Row>
    </>
  );
};

export default ViewImportPage;
